const PHONE_FORMAT_SPACE = '\u00A0';

export function getPhoneDigits(phone) {
  return String(phone || '').replace(/\D/g, '');
}

export function formatRussianPhone(digits) {
  const inputValue = String(digits || '').slice(0, 11);
  let formattedValue = '+7';

  if (inputValue.length > 1) {
    formattedValue += `${PHONE_FORMAT_SPACE}(${inputValue.slice(1, 4)}`;
  }

  if (inputValue.length >= 5) {
    formattedValue += `)${PHONE_FORMAT_SPACE}${inputValue.slice(4, 7)}`;
  }

  if (inputValue.length >= 8) {
    formattedValue += `-${inputValue.slice(7, 9)}`;
  }

  if (inputValue.length >= 10) {
    formattedValue += `-${inputValue.slice(9, 11)}`;
  }

  return formattedValue;
}

export function formatExplicitInternationalPhone(digits) {
  const inputValue = String(digits || '');

  if (!inputValue) {
    return '+';
  }

  if (inputValue.startsWith('7')) {
    return formatRussianPhone(inputValue);
  }

  return `+${inputValue.slice(0, 16)}`;
}

export function formatPhoneInput(value) {
  const rawValue = String(value || '');
  const hasExplicitCountryCode = rawValue.trim().startsWith('+');
  const digits = getPhoneDigits(rawValue);

  if (!digits) {
    return hasExplicitCountryCode ? '+' : '';
  }

  if (hasExplicitCountryCode) {
    return formatExplicitInternationalPhone(digits);
  }

  if (digits[0] === '8') {
    return formatRussianPhone(`7${digits.slice(1)}`);
  }

  if (digits[0] === '7') {
    return formatRussianPhone(digits);
  }

  if (digits[0] === '9') {
    return formatRussianPhone(`7${digits}`);
  }

  return `+${digits.slice(0, 16)}`;
}

export function getPhoneApiValue(phone) {
  return getPhoneDigits(phone);
}

export function handlePhoneInputKeyDown(event, onValueChange) {
  const input = event.currentTarget;
  const isOnlyCaret = input.selectionStart === input.selectionEnd;

  if (!isOnlyCaret || !input.value.startsWith('+')) {
    return false;
  }

  const shouldRemoveLeadingPlus = (
    (event.key === 'Backspace' && input.selectionStart === 1)
    || (event.key === 'Delete' && input.selectionStart === 0)
  );

  if (!shouldRemoveLeadingPlus) {
    return false;
  }

  event.preventDefault();
  onValueChange(input.value.slice(1));

  window.requestAnimationFrame(() => {
    input.setSelectionRange(0, 0);
  });

  return true;
}

export function isPhoneValid(phone) {
  const digits = getPhoneDigits(phone);

  if (digits.startsWith('7')) {
    return digits.length === 11;
  }

  return digits.length >= 10 && digits.length <= 16;
}

export function formatConfirmedPhone(phone) {
  const inputValue = String(phone || '').trim();

  if (!inputValue) {
    return '';
  }

  const digits = getPhoneDigits(inputValue);

  if (!digits) {
    return '';
  }

  if (digits.startsWith('7') && digits.length === 11) {
    return formatRussianPhone(digits);
  }

  return `+${digits}`;
}
